import Warranty from 'components/Main/Warranty/Warranty'
import useFetch from 'elements/Hooks/useFetch'
import React from 'react'

function WarrantyCont() {
  const { data: list, fetching, fetch } = useFetch({
    url: '/warranty',
  })

  return (
    <Warranty
      {...{
        list,
        fetching,
        fetch,
      }}
    />
  )
}

export default WarrantyCont
